import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Tabs from 'components/Tabs';
import { Breakpoints } from 'styles/Constants';

import SectionWrapper from 'pages/Layout/SectionWrapper';

import AmbassadorProfile from './AmbassadorProfile';
import ChangePassword from '../ChangePassword';

const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenWidth;
};

const AmbassadorSettings = () => {
  const { t } = useTranslation(['settings']);
  const screenWidth = useScreenWidth();

  const isMobile = screenWidth < parseInt(Breakpoints.mediumLarge);
  const orientation = isMobile ? 'horizontal' : 'vertical';

  return (
    <SectionWrapper>
      <h1>{t('settings')}</h1>
      <Tabs
        orientation={orientation}
        tabsTitle={[
          { id: 1, label: t('account') },
          { id: 2, label: t('password') }
        ]}
        tabsContent={[
          { id: 1, children: <AmbassadorProfile /> },
          { id: 2, children: <ChangePassword /> }
        ]}
      />
    </SectionWrapper>
  );
};

export default AmbassadorSettings;
